import { Box, Grid, Card, CardContent, Typography, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import {
  Dashboard,
  People,
  Money,
  Inventory,
  Settings,
  ShoppingCart,
  ShoppingBasket,
  AttachFileSharp,
  SmartToy,
} from '@mui/icons-material';

// Menu items with Material-UI icons
const menuItems = [
    {
    id: 1,
    title: 'Catalogs',
    description: 'Download Price list',
    icon: <AttachFileSharp fontSize="large" />,
    color: '#1d5576',
    path: '/catalogs'
  },
  {
    id: 2,
    title: 'Products',
    description: 'Browse product catalog',
    icon: <Inventory fontSize="large" />,
    color: '#1d5576',
    path: '/products/list'
  },
  // {
  //   id: 3,
  //   title: 'Order Status',
  //   description: 'View customer orders',
  //   icon: <ShoppingCart fontSize="large" />,
  //   color: '#1d5576',
  //   path: '/orders'
  // },
  {
    id: 4,
    title: 'Brands',
    description: 'Marketing materials & resources',
    icon: <Dashboard fontSize="large" />,
    color: '#1d5576',
    path: '/marketing'
  },
  {
    id: 5,
    title: 'Quotations',
    description: 'Your quote basket & history',
    icon: <ShoppingBasket fontSize="large" />,
    color: '#1d5576',
    path: '/quotations',
  },
  {
    id: 6,
    title: 'Gibson AI',
    description: 'Ask anything about the portal',
    icon: <SmartToy fontSize="large" />,
    color: '#1d5576',
    path: '/ai-assistant',
  },
  // {
  //   id: 5,
  //   title: 'Catalogs',
  //   description: 'Catalog management',
  //   icon: <AttachFileSharp fontSize="large" />,
  //   color: '#1d5576',
  //   path: '/catalogs'
  // },
  // {
  //   id: 6,
  //   title: 'Settings',
  //   description: 'Configure application',
  //   icon: <Settings fontSize="large" />,
  //   color: '#1d5576',
  //   path: '/settings'
  // },
  // {
  //   id: 6,
  //   title: 'Users',
  //   description: 'Manage user accounts',
  //   icon: <People fontSize="large" />,
  //   color: '#1d5576'
  //   path: '/users'
  // }
];

const MenuCard = styled(Card)(({ theme, color }) => ({
  height: 200, // Fixed height for all screens
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
  border: `2px solid ${color}20`,
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: theme.shadows[8],
    border: `2px solid ${color}`,
    backgroundColor: `${color}08`
  }
}));

const Home = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const aiAccess = localStorage.getItem('ai_access') !== 'false';
  const visibleMenuItems = menuItems.filter((item) => item.path !== '/ai-assistant' || aiAccess);

  const handleMenuClick = (menuItem) => {
    console.log('Navigating to:', menuItem.path);
    
    // Navigate to the specified route
    if (menuItem.path) {
      navigate(menuItem.path);
    } else {
      console.warn('No path defined for:', menuItem.title);
    }
  };

  return (
    <Box 
      sx={{ 
        flexGrow: 1, 
        p: { xs: 2, sm: 3, md: 4 },
        minHeight: 'calc(100vh - 144px)', // Adjust based on your header height
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}
    >
      {/* Centered Title */}
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          mb: 4,
          textAlign: 'center',
          fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
          fontWeight: 600
        }}
      >
        Main Menu
      </Typography>
      
      {/* Centered Grid Container */}
      <Box 
        sx={{ 
          width: '100%',
          maxWidth: '1200px', // Maximum width for large screens
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Grid 
          container 
          spacing={3}
          justifyContent="center" // Center the grid items
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: '600px', md: '900px', lg: '1200px' }
          }}
        >
          {visibleMenuItems.map((item) => (
            <Grid 
              item 
              xs={12}   // Full width on mobile
              sm={6}    // 2 columns on tablets
              md={4}    // 3 columns on desktop
              key={item.id}
              sx={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <MenuCard 
                color={item.color}
                onClick={() => handleMenuClick(item)}
                sx={{
                  width: '300px', // Full width mobile, fixed on larger screens
                }}
              >
                <CardContent 
                  sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    p: 2
                  }}
                >
                  <Box 
                    sx={{ 
                      color: item.color, 
                      mb: 1,
                      '& .MuiSvgIcon-root': {
                        fontSize: '3rem' // Fixed icon size for consistency
                      }
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography 
                    variant="h6" 
                    component="div" 
                    sx={{ fontWeight: 'bold', fontSize: '1.25rem' }}
                  >
                    {item.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ fontSize: '1rem', mt: 1, textAlign: 'center' }}
                  >
                    {item.description}
                  </Typography>
                </CardContent>
              </MenuCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default Home;